import React from 'react';
import PropTypes from 'prop-types';
import { withTranslation } from 'react-i18next';
// material-ui components
import { Grid } from '@mui/material';
import { Dialog, Button, IconButton } from '@totalsoft/rocket-ui';
import { SummaryAssetImage, SummaryDeleteAsset } from './OfferAssetListStyles';
import { Delete } from '@mui/icons-material';

export const OfferAssetListSummary = ({
  asset,
  idx,
  t,
  onDeleteAsset,
  assetImage,
  deleteConfirmationModal,
  setDeleteConfirmationModal,
  showDeleteButton,
  onDelete,
  deleting
}) => {
  const handleDeleteAssetModalClose = event => {
    event.preventDefault();
    event.stopPropagation();
    setDeleteConfirmationModal(false);
  };

  const handleDeleteAssetPositive = asset => event => {
    event.preventDefault();
    event.stopPropagation();
    setDeleteConfirmationModal(false);
    onDeleteAsset(asset);
  };

  const handleDeleteAssetNegative = event => {
    event.preventDefault();
    event.stopPropagation();
    setDeleteConfirmationModal(false);
  };
  return (
    <>
      <Grid container justifyContent='space-between' spacing={1} xs>
        <Grid item container xs={12} md='auto' flexDirection='column' justifyContent='center' spacing={1}>
          <Grid item display='flex' gap={1}>
            <strong> {t('OfferEdit.Asset.Financial.AcquisitionPriceWithoutVat')} </strong> :
            <span id={'offerAssetItemCard_' + idx + '_summary_acquisitionPriceWithoutVat'}>
              {`${t('DECIMAL', { number: asset.acquisitionPriceWithoutVat })} ${asset.currencyCode}` || ''}
            </span>
          </Grid>
          <Grid item display='flex' gap={1}>
            <strong> {t('OfferEdit.Asset.Financial.AcquisitionPriceWithVat')} </strong> :
            <span id={'offerAssetItemCard_' + idx + '_summary_acquisitionPriceWithVat'}>
              {`${t('DECIMAL', { number: asset.acquisitionPriceWithVat })} ${asset.currencyCode}` || ''}
            </span>
          </Grid>
        </Grid>
        <Grid item container xs={12} md justifyContent='space-between'>
          <Grid item container justifyContent={{ xs: 'start', lg: 'end' }}>
            {assetImage && <SummaryAssetImage src={assetImage} alt='...' />}
          </Grid>
          <SummaryDeleteAsset item container justifyContent='end' alignItems='end'>
            {showDeleteButton && (
              <IconButton
                id={'offerAssetItemCard_' + idx + 'deleteBtn'}
                variant='text'
                color='primary'
                size='small'
                onClick={onDelete}
                disabled={deleting}
                tooltip={t('Delete')}
              >
                <Delete />
              </IconButton>
            )}
          </SummaryDeleteAsset>
        </Grid>
      </Grid>
      <Dialog
        open={deleteConfirmationModal}
        onClose={handleDeleteAssetModalClose}
        aria-labelledby='deleteAsset-title'
        aria-describedby='deleteAsset-description'
        title={t('OfferEdit.Asset.DeleteModal.Title')}
        content={t('OfferEdit.Asset.DeleteModal.Message', {
          data: { assetDescription: asset.assetDescription }
        })}
        actions={
          <>
            <Button id={'offerAssetItemCard_' + idx + 'delete_acceptBtn'} autoFocus onClick={handleDeleteAssetPositive(asset)}>
              {t('OfferEdit.Asset.DeleteModal.AcceptButton')}
            </Button>
            <Button id={'offerAssetItemCard_' + idx + 'delete_rejectBtn'} onClick={handleDeleteAssetNegative}>
              {t('OfferEdit.Asset.DeleteModal.RejectButton')}
            </Button>
          </>
        }
      />
    </>
  );
};

OfferAssetListSummary.propTypes = {
  asset: PropTypes.object.isRequired,
  idx: PropTypes.number,
  onDeleteAsset: PropTypes.func.isRequired,
  t: PropTypes.func.isRequired,
  assetImage: PropTypes.string,
  deleteConfirmationModal: PropTypes.bool.isRequired,
  setDeleteConfirmationModal: PropTypes.func.isRequired,
  showDeleteButton: PropTypes.bool.isRequired,
  onDelete: PropTypes.func.isRequired,
  deleting: PropTypes.bool.isRequired
};

export default withTranslation()(OfferAssetListSummary);
